import React from 'react';

interface BirthdayFieldProp {
  applicant: string;
  index: string;
  setGender: (event, string, index) => void;
}

export const GenderField: React.FC<BirthdayFieldProp> = ({ applicant, index, setGender }) => {
  return (
    <div className="dental-repeater-item even">
      <h6 className="field-label">
        Gender<sup className="dent-required-field">*</sup>
      </h6>
      <div className="btn-group gender-input">
        <label className="btn-type-radio">
          <input
            className="btn-radio"
            name={index}
            onChange={e => {
              setGender(e, applicant, index);
            }}
            required
            type="radio"
            value="0"
          />{' '}
          Male
        </label>
        <label className="btn-type-radio">
          <input
            className="btn-radio"
            name={index}
            onChange={e => {
              setGender(e, applicant, index);
            }}
            type="radio"
            value="1"
          />{' '}
          Female
        </label>
      </div>
    </div>
  );
};
